import type { AgentIconType } from '@confluence/agent-user-dual-avatar/entry-points/agentIconType.ts';

const agentBrands: readonly { name: string; icon: AgentIconType }[] = [
	{ name: 'Claude Code', icon: 'claude' },
	{ name: 'Claude', icon: 'claude' },
	{ name: 'Codex', icon: 'codex' },
	{ name: 'Rovo', icon: 'rovo' },
	{ name: 'Cursor', icon: 'cursor' },
	{ name: 'ChatGPT', icon: 'chatgpt' },
	{ name: 'Dia', icon: 'dia' },
];

/** Keep custom agents' own avatars; recognize brand accounts and integration suffixes. */
export const getCollaboratorAgentIcon = (displayName: string): AgentIconType | undefined =>
	agentBrands.find(({ name }) => displayName === name || displayName.startsWith(`${name} (`))?.icon;
